module.exports = __webpack_public_path__ + "static/media/indisponivel.cd6e9459.jpg";